module.exports = __webpack_public_path__ + "static/kurt.67f7ee96.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/kurt.png
// module id = 572
// module chunks = 263791100135453